import React from 'react';
import { Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { logJobApply, useGetCheckSubscriptionMutation, useJobApplyMutation } from 'services';
import Loader from '../Loader';
import { useNavigate } from 'react-router-dom';
import useCommonStore from 'store/common';
import useTranslate from 'hooks/useTranslate';

interface JobApplyBtnProps {
	isApplied: boolean;
	setIsApplied: (isFavourite: boolean) => void;
	jobId: number;
	isJobAssessment: boolean;
	handleClick: any;
	modalConfig: any;
	setModalConfig: any;
	jobApplyStatus: string;
}

const JobApplyBtn: React.FC<JobApplyBtnProps> = ({
	isApplied,
	setIsApplied,
	jobId,
	isJobAssessment = false,
	handleClick = () => null,
	setModalConfig,
	jobApplyStatus,
}) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { hideCommonModal }: any = useCommonStore((state) => state);
	const { mutateAsync: jobApply, isPending: isPendingFav } = useJobApplyMutation();
	const { mutateAsync: checkSubscriptionMutation } = useGetCheckSubscriptionMutation();
	const handleYes = () => {
		hideCommonModal();
		navigate(`/seeker/apply-job-assessment/${jobId}`);
	};

	const handleModalClick = () => {
		navigate(`/job-detail/${jobId}`);
	};

	const handleJobApplyBtnClick = (evt: any, type: string = 'confirmModal') => {
		evt.stopPropagation();
		logJobApply(jobId);
		const isLoggedIn = handleClick();

		if (!isApplied && isLoggedIn) {
			checkSubscriptionMutation('apply-job').then((res: any) => {
				if (res.success) {
					jobApply({ jobId })
						.then((jobRes: any) => {
							if (jobRes?.success) {
								setIsApplied(!isApplied);
							}
						})
						.catch((error) => {
							console.error('Failed to apply for the job:', error);
							toast.error(translate('ToastMessage.anUnexpectedErrorOccurred')); // Notify the user of the failure
						});

					if (isJobAssessment) {
						setModalConfig({
							visible: true,
							id: jobId,
							type,
							onClick: handleYes,
							data: { title: translate('Modal.wantToGiveAssessment') },
						});
					} else {
						setModalConfig({
							visible: true,
							id: jobId,
							onClick: handleModalClick,
							type: 'successAssessmentModal',
						});
					}
				} else {
					setModalConfig({
						visible: true,
						type: 'subscriptionModal',
					});
				}
			});
		}
	};

	const getJobApplyStatus = () => {
		switch (jobApplyStatus) {
			case 'applied':
				return translate('Button.applied');
			case 'hired':
				return translate('Button.hired');
			case 'offered':
				return translate('Button.offered');
			case 'screened':
				return translate('Button.screened');
			case 'interview':
				return translate('Button.interview');
			case 'rejected':
				return translate('Button.rejected');
			default:
				return translate('Button.applied');
		}
	};

	return (
		<>
			{isPendingFav ? (
				<Loader />
			) : isApplied ? (
				<Button
					className="filled-btn gray-btn rounded-pill lh-1"
					onClick={(evt) => evt.stopPropagation()}
				>
					{getJobApplyStatus()}
				</Button>
			) : (
				<Button className="filled-btn rounded-pill lh-1" onClick={handleJobApplyBtnClick}>
					{translate('Button.apply')}{' '}
				</Button>
			)}
		</>
	);
};

export default JobApplyBtn;
